import { render } from "./PushNotificationMaster.vue?vue&type=template&id=7c2718c9&scoped=true"
import script from "./PushNotificationMaster.vue?vue&type=script&lang=js"
export * from "./PushNotificationMaster.vue?vue&type=script&lang=js"

import "./PushNotificationMaster.vue?vue&type=style&index=0&id=7c2718c9&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2718c9"]])

export default __exports__